import { getCalendarData, DEFAULT_MIN_DATE_ISO } from './calendarTasksIndex'
import { gantt } from 'dhtmlx-gantt'

const Defaults = { DEFAULT_ROW_HEIGHT: 30, WRAPPING_ROW_HEIGHT: 44 }

export const getGanttData = async (organizationId, projectId = null, defaultDate = DEFAULT_MIN_DATE_ISO, organizationIds = null) => {
  const remoteData = await getCalendarData(organizationId, projectId, defaultDate, organizationIds)
  const projectsToPublish = []
  const categoriesToPublish = []
  const siteTasksList = remoteData.calendarTasks.map((site_task) => {
    projectsToPublish.push(site_task.project_id)
    categoriesToPublish.push(`${site_task.project_id}:${site_task.category_id}`)
    return {
      id: `task-${site_task.id}`,
      type: 'SiteTask',
      parent: site_task.site_task_group_id ? `siteTaskGroup-${site_task.site_task_group_id}` : `${site_task.project_id}:${site_task.category_id}`,
      text: site_task.title,
      start_date: new Date(site_task.start_date || remoteData.settings.minDate),
      end_date: new Date(site_task.end_date || remoteData.settings.minDate),
      duration: site_task.estimated_days,
      progress: site_task.percentage_completed ? site_task.percentage_completed / 100.0 : null,
      estimated_days: site_task.estimated_days,
      row_height: Defaults.WRAPPING_ROW_HEIGHT,
      cellClass: 'cmp-task',
      // Store original category for validation
      originalCategoryId: `${site_task.project_id}:${site_task.category_id}`,
    }
  })

  // Also add categories from SiteTaskGroups that have task_category_id
  remoteData.siteTaskGroups.site_task_groups.forEach((siteTaskGroup) => {
    if (siteTaskGroup.task_category_id) {
      projectsToPublish.push(siteTaskGroup.project_id)
      categoriesToPublish.push(`${siteTaskGroup.project_id}:${siteTaskGroup.task_category_id}`)
    }
  })
  const projectsList = Array.from(new Set(projectsToPublish)).map((project_id) => {
    const project = remoteData.projects.find((project) => project.id == project_id)
    return project ? {
      id: project.id,
      type: 'Project',
      text: project.title,
      open: true,
      siteRevisionTitle: project.sites?.[0]?.revision_title || '',
      row_height: Defaults.DEFAULT_ROW_HEIGHT,
    } : null
  }).filter(Boolean)

  const siteTaskGroups = remoteData.siteTaskGroups.site_task_groups.map((siteTaskGroup) => {
    // Determine parent based on hierarchy:
    // 1. If has parent_id, use that (nested group)
    // 2. If has task_category_id, use that (group under category)
    // 3. Otherwise use project_id (group at root)
    let parent
    if (siteTaskGroup.parent_id) {
      parent = `siteTaskGroup-${siteTaskGroup.parent_id}`
    } else if (siteTaskGroup.task_category_id) {
      parent = `${siteTaskGroup.project_id}:${siteTaskGroup.task_category_id}`
    } else {
      parent = siteTaskGroup.project_id
    }

    return {
      id: `siteTaskGroup-${siteTaskGroup.id}`,
      type: gantt.config.types.project, // Changed to project type
      text: siteTaskGroup.name,
      start_date: new Date(siteTaskGroup.start_date || remoteData.settings.minDate),
      end_date: new Date(siteTaskGroup.end_date || remoteData.settings.minDate),
      duration: siteTaskGroup.estimated_days || 0,
      progress: (siteTaskGroup.percentage_completed || 0) / 100.0,
      row_height: Defaults.WRAPPING_ROW_HEIGHT,
      estimated_days: siteTaskGroup.estimated_days,
      parent: parent,
      open: true,
      // Add a custom property to retain the original type for styling if needed
      originalType: 'SiteTaskGroup',
      // Store task_category_id for validation
      taskCategoryId: siteTaskGroup.task_category_id,
      dateMode: siteTaskGroup.date_mode,
    }
  })

  const categoriesList = Array.from(new Set(categoriesToPublish)).map((project_and_category_id) => {
    const [project_id, category_id] = project_and_category_id.split(':')
    const category = remoteData.taskCategories.find((category) => category.id == category_id)
    return {
      id: project_and_category_id,
      type: 'Category',
      text: category.short || category.title,
      parent: project_id,
      open: true,
      row_height: Defaults.DEFAULT_ROW_HEIGHT,
    }
  })

  const events = [...projectsList, ...categoriesList, ...siteTasksList, ...siteTaskGroups]
  return {
    data: events,
    links: [],
  }
}
